import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core'
import { IDynamicRenderContainer } from '../../models/dynamic-render-container'
import { DynamicRenderService } from '../../services/dynamic-render.service'


@Component({
  selector: 'adex-dynamic-render-container',
  template: ``,
  styleUrls: [ './dynamic-render-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicRenderContainerComponent implements IDynamicRenderContainer, OnDestroy {
  private innerName: string
  private readonly viewMap: Map<string, HTMLElement> = new Map()

  constructor(
    private readonly store: DynamicRenderService,
    private readonly el: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {
  }

  public get name() {
    return this.innerName
  }

  @Input()
  public set name(name: string) {
    this.innerName = name
    this.store.registerContainer(name, this)
  }

  private get element() {
    return this.el.nativeElement
  }

  public ngOnDestroy(): void {
    this.viewMap.forEach((_, name) => this.store.remove(name))
    this.store.unregisterContainer(this.innerName)
  }

  public renderView(name: string, view: HTMLElement): void {
    if (this.viewMap.has(name)) throw new Error(`View ${ name } is rendered`)
    this.renderer.appendChild(this.element, view)
    this.viewMap.set(name, view)
  }

  public removeView(name: string): void {
    if (!this.viewMap.has(name)) throw new Error(`View ${ name } is not rendered`)
    const view = this.viewMap.get(name)
    this.renderer.removeChild(this.element, view)
    this.viewMap.delete(name)
  }

}
